import { useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import AnimatedCol from "../../../../../components/AnimatedCol";
import RenderFor, { BM_TYP } from "../../../../../components/RenderFor";
import NumberOfTests from "./NumberOfTests";
import DispersionCoefficient from "./DispersionCoefficient";
import DispersionCoefficientImage from "./DispersionCoefficientImage";
import PartialSafetyFactor from "./PartialSafetyFactor";
import PartialSafetyFactorImage from "./PartialSafetyFactorImage";
import ModelFactor from "./ModelFactor";
import TestLoad from "./TestLoad";
import {
  setNumberOfTestsForTypeDIN,
  selectDispersionCoefficient,
  selectNumberOfTestsForTypeDIN,
  selectModelFactor,
  setDispersionCoefficientByNumberOfTests,
} from "../../../../../store/slices/lvTextSlice";
import { selectBelastungsartUndRichtung } from "../../../../../store/slices/belastungsartUndRichtungSlice";
import { selectBemessungslast } from "../../../../../store/slices/bemessungslastSlice";
import { DRUCKPFAHL, ZUGPFAHL } from "../../../../../constants";

export default function PositionTestLoadsForDINEN19971DIN1054EAPiles() {
  const dispatch = useDispatch();

  const numberOfTestLoads = useSelector(selectNumberOfTestsForTypeDIN);
  const dispersionCoefficient = useSelector(selectDispersionCoefficient);

  const loadDirection = useSelector(selectBelastungsartUndRichtung);
  const partialSafetyFactor =
    loadDirection === DRUCKPFAHL ? 1.1 : loadDirection === ZUGPFAHL ? 1.15 : "";

  const modelFactor = useSelector(selectModelFactor);

  const designLoad = useSelector(selectBemessungslast);
  const testLoad =
    loadDirection === DRUCKPFAHL
      ? designLoad * partialSafetyFactor * dispersionCoefficient
      : loadDirection === ZUGPFAHL
        ? designLoad * partialSafetyFactor * dispersionCoefficient * modelFactor
        : "";

  const [showPartialSafetyFactorImage, setShowPartialSafetyFactorImage] = useState(false);
  const [showDispersionCoefficientImage, setShowDispersionCoefficientImage] = useState(false);

  const setNumberOfTests = (value) => {
    dispatch(setNumberOfTestsForTypeDIN(value));
    dispatch(setDispersionCoefficientByNumberOfTests());
  };

  return (
    <div className="mt-5">
      <Row>
        <AnimatedCol>
          <NumberOfTests value={numberOfTestLoads} set={setNumberOfTests} />
        </AnimatedCol>
      </Row>
      <Row>
        <AnimatedCol>
          <DispersionCoefficient
            value={dispersionCoefficient}
            showModal={setShowDispersionCoefficientImage}
          />
        </AnimatedCol>
        <RenderFor types={[BM_TYP.EUROCODE_7, BM_TYP.GERMANY]}>
          <div className="col-md-auto offset-md-8" style={{ height: "0px" }}>
            <DispersionCoefficientImage
              show={showDispersionCoefficientImage}
              setShow={setShowDispersionCoefficientImage}
            />
          </div>
        </RenderFor>
      </Row>
      <Row>
        <AnimatedCol>
          <PartialSafetyFactor
            value={partialSafetyFactor}
            loadDirection={loadDirection}
            showModal={setShowPartialSafetyFactorImage}
          />
        </AnimatedCol>
        <RenderFor types={[BM_TYP.EUROCODE_7, BM_TYP.GERMANY]}>
          <div className="col-md-auto offset-md-8" style={{ height: "0px" }}>
            <PartialSafetyFactorImage
              show={showPartialSafetyFactorImage}
              setShow={setShowPartialSafetyFactorImage}
            />
          </div>
        </RenderFor>
      </Row>
      {loadDirection === ZUGPFAHL && (
        <Row>
          <AnimatedCol>
            <ModelFactor value={modelFactor} />
          </AnimatedCol>
        </Row>
      )}
      <Row>
        <AnimatedCol>
          <TestLoad value={testLoad} loadDirection={loadDirection} />
        </AnimatedCol>
      </Row>
    </div>
  );
}
